
export const validate_account_credentials = async (username, password) => {
    const result_data = {
        acct_id: username,
        secret: password,
    }
    if (!username || !password) {
        result_data.authentication_code = 'fail'
        result_data.authorization_code = 'fail'
    } else if (username == 'tootles' && password == 'smellmyfarts69') {
        result_data.authentication_code = 'pass'
        result_data.authorization_code = 'pass'
    }
    return result_data
}
